import { render, staticRenderFns } from "./WorkingPoints.vue?vue&type=template&id=15c704fc&scoped=true"
import script from "./WorkingPoints.vue?vue&type=script&lang=js"
export * from "./WorkingPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c704fc",
  null
  
)

export default component.exports